module.exports = __webpack_public_path__ + "static/media/Investor@3x.7cdef304.png";